import { render, staticRenderFns } from "./CompilaQuestionarioRicognizione.vue?vue&type=template&id=10d30c92&scoped=true&"
import script from "./CompilaQuestionarioRicognizione.vue?vue&type=script&lang=js&"
export * from "./CompilaQuestionarioRicognizione.vue?vue&type=script&lang=js&"
import style0 from "./CompilaQuestionarioRicognizione.vue?vue&type=style&index=0&id=10d30c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d30c92",
  null
  
)

export default component.exports